import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { updateShowMoveModal as updateShowMoveModalTA } from 'actions/moveModal';
import { hideFolderHierarchy, showFolderHierarchy } from 'actions/shareVideo';
import {
  updateCheckedItems,
  updateShowMoveModal,
} from 'actions/videosDashboard';
import { SHARE_VIDEO_MOVE_CLICK } from 'constants/events';
import * as analytics from 'utilities/analytics';

import { TEAM_ACCOUNT_TYPES } from '../../../../../shared/constants/accountTypes';

import Dropdown from 'components/ui-components/dropdown';
import Tooltip from 'components/ui-components/tooltip';

import './styles.less';

class MoveToFolderBar extends React.PureComponent {
  render() {
    const {
      folders,
      prev,
      next,
      showMoveToFolder,
      usePublicLinks,
    } = this.props;

    const foldersWithoutLast = folders.slice(0, -1);
    const lastFolder = folders.slice(-1)[0];
    const folderLevel = folders.length - 1;

    if (!folders || folders.length == 0) {
      return null;
    }

    return (
      <div className="move-to-folder">
        <Dropdown
          outsideClickIgnoreClass="move-to-folder-multiple-icon"
          onClickOutside={this.props.onClickHideHierarchy}
          className="move-to-folder-dropdown"
          show={this.props.showFolderHierarchy}
        >
          {foldersWithoutLast.map((folder, index) => (
            <a
              href={this.getFolderUrl(
                foldersWithoutLast.slice(0, index + 1),
                usePublicLinks
              )}
              className="move-to-folder-dropdown-item"
              key={folder.id}
            >
              {folder.name}
            </a>
          ))}
        </Dropdown>
        {folders.length > 1 && (
          <div className="move-to-folder-folders">
            <div
              className={`move-to-folder-multiple-icon ${
                folderLevel > 1 ? '' : 'disabled'
              }`}
              onClick={this.handleClickFolderIcon}
            >
              <span>{folderLevel > 1 ? folderLevel : ''}</span>
            </div>
            {folders.length == 2 ? (
              <a
                href={this.getFolderUrl(folders, usePublicLinks)}
                className="folder-normal"
              >
                {lastFolder.name}
              </a>
            ) : (
              <a
                href={this.getFolderUrl(folders, usePublicLinks)}
                className="folder-normal"
              >
                {lastFolder.name}
              </a>
            )}
          </div>
        )}
        <div className="move-to-folder-actions">
          {showMoveToFolder && (
            <span className="move" onClick={this.handleClickMove}>
              Move to Folder
            </span>
          )}
          {(next || prev) && (
            <Fragment>
              <a className="prev" href={prev && prev.url} disabled={!prev}>
                {prev && <Tooltip>{prev.name}</Tooltip>}
              </a>
              <a className="next" href={next && next.url} disabled={!next}>
                {next && <Tooltip>{next.name}</Tooltip>}
              </a>
            </Fragment>
          )}
        </div>
      </div>
    );
  }

  getFolderUrl = (folders, usePublicLinks = false) => {
    const segments = folders.reduce((segments, folder, index) => {
      if (index == 0) {
        return segments.concat(folder.special_id || folder.id);
      }

      return segments.concat(folder.name);
    }, []);

    const encodedNames = segments.map(encodeURIComponent).join('/');

    if (usePublicLinks) {
      return `/share/folder/${encodedNames}`;
    }

    // Private links already contain the special_id such as 'my-videos'
    return `/${encodedNames}`;
  };

  handleClickMove = event => {
    const { videoId, videoName, folders, user } = this.props;

    event.preventDefault();
    this.props.onClickMove(videoId, videoName, folders, user.account_type);
  };

  handleClickFolderIcon = () => {
    if (this.props.showFolderHierarchy) {
      this.props.onClickHideHierarchy();
    } else {
      this.props.onClickShowHierarchy();
    }
  };
}

const mapStateToProps = (state, ownProps) => {
  const sv = state.share_video;
  const folders = ownProps.folders || state.share_video.video_folders;
  const { current: user } = state.user;

  return {
    folders,
    videoId: sv.video ? sv.video.id : null,
    videoName: sv.video ? sv.video.name : null,
    prev: sv.video ? sv.video.prev : null,
    next: sv.video ? sv.video.next : null,
    showFolderHierarchy: sv.show_folder_hierarchy,
    showMoveToFolder:
      (sv.current_user_is_owner || sv.video_is_team_shared) &&
      folders.length == 1,
    usePublicLinks: !sv.current_user_is_owner && !sv.video_is_team_shared,
    user,
  };
};

const mapDispatchToProps = dispatch => ({
  onClickShowHierarchy: () => dispatch(showFolderHierarchy()),
  onClickHideHierarchy: () => dispatch(hideFolderHierarchy()),
  onClickMove: (id, name, folders, accountType) => {
    analytics.track(SHARE_VIDEO_MOVE_CLICK, {
      folder_id: folders[0].id,
      folder_special_id: folders[0].special_id,
      video_name: name,
      video_id: id,
    });

    dispatch(
      updateCheckedItems([
        {
          id,
          name,
          type: 'video',
        },
      ])
    );

    if (TEAM_ACCOUNT_TYPES.includes(accountType)) {
      dispatch(updateShowMoveModalTA(true));
    } else {
      dispatch(updateShowMoveModal(true));
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MoveToFolderBar);
